import React, { useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AdminGuard, PartnerGuard } from './guards/RolesGuard';
import { UserGuard } from './guards/UserGuard';
import { routes } from './router/routes';
import RouteWrapper from './router/RouteWrapper';
import { navigationAgents } from './utils/navigation-constants/navigation-partner';
import Cookies from 'js-cookie';
import { DOMAIN } from './config';
import ExternalRedirect from './router/ExternalRedirect';

const App = () => {
    const redirectNotExistingRoutes = UserGuard() ? ((AdminGuard() || PartnerGuard()) ? '/insights' : '/login') : '/login'
    const [redirectPartner, setRedirectPartner] = useState<any>()
    const token = Cookies.get('accessToken') || localStorage.getItem('accessToken');
    const navigation: any = navigationAgents

    useEffect(() => {
        if (navigation && token && (!redirectPartner || redirectPartner === DOMAIN || '/login')) {
            const findIfInsightsExists = (navigation && navigation?.length > 0) && navigation?.find((item: any) => item?.path === '/insights')
            if (!findIfInsightsExists) {
                const getFirstPage = (navigation && navigation?.length > 0) && navigation?.[0]
                setRedirectPartner(getFirstPage?.path)
            } else if (!AdminGuard()) {
                setRedirectPartner('/insights')
            }
        }
        else if (!token && !redirectPartner) {
            setRedirectPartner(DOMAIN || '/login');
            // (window as any).Intercom('shutdown');
        }
    }, [navigation, token])

	const redirect = token ? redirectPartner || redirectNotExistingRoutes || DOMAIN : DOMAIN
	const isExternal = redirect?.startsWith('http');

    return (
        <div className='App !font-dm_sansregular'>
            <Routes>
                {routes?.map((route: any, index: number) => {
                    const children = route?.childrens
                    return (
                        children ? (
                            <React.Fragment key={index}>
                                {route.index && <Route
                                    path={route.path}
                                    element={<Navigate to={route.index} replace />}
                                />}
                                <Route path={route.path} element={<RouteWrapper guard={route.guard} element={route.element} />}>
                                    {children?.map((r: any, i: number) => {
                                        return (
                                            <Route key={i} path={r.path} element={<RouteWrapper guard={r.guard || route.guard} element={r.element} />} />
                                        )
                                    }
                                    )}
                                </Route>
                            </React.Fragment>
                        ) : (
                            <Route
                                key={index}
                                path={route.path}
                                element={<RouteWrapper guard={route.guard} element={route.element} />}
                            />
                        )
                    )
                }
                )}
                <Route path='*' element={isExternal ? <ExternalRedirect url={redirect} /> : <Navigate replace to={redirect} />} />
            </Routes>
        </div>
    );
}

export default App;
